const keyPressed = (provider) => {
    let p = provider.p;

    if (!provider.enableHotKeys) {
        provider.tools.currentTool.pressKeyHotKeysDisabled(p.keyCode);
        return;
    }

    if (onlySubKey(p.ALT, p)) {
        switch (p.keyCode) {
            case 73: // I
                provider.settings.showImage = !provider.settings.showImage;
                return false;
        }
        return provider.tools.currentTool.pressKeyWithAlt(p.keyCode);
    }

    if (onlySubKey(p.CONTROL, p)) {
        switch (p.keyCode) {

        }
        return provider.tools.currentTool.pressKeyWithControl(p.keyCode);
    }

    if (onlySubKey(p.SHIFT, p)) {
        switch (p.keyCode) {
            case 71: // G
                provider.settings.showGrid = !provider.settings.showGrid;
                return false;
            case 76: // L
                provider.settings.showLabels = !provider.settings.showLabels;
                return false;
            case 82: // R
                provider.view.reset();
                return false;
        }
        return provider.tools.currentTool.pressKeyWithShift(p.keyCode);
    }

    switch (p.keyCode) {
        case 67: // C
            provider.tools.setTool('select');
            return;
        case 69: // E
            provider.sideBar.setTab('elements');
            return;
        case 72: // H
            provider.tools.setTool('help');
            return;
        case 73: // I
            provider.sideBar.setTab('info');
            return;
        case 80: // P
            provider.sideBar.setTab('plants');
            return;
        case 187: // +
            provider.view.zoomIn();
            return;
        case 188: // ,
            provider.tools.setTool('settings');
            return;
        case 189: // -
            provider.view.zoomOut();
            return;
    }

    return provider.tools.currentTool.pressKey(p.keyCode);
}

const onlySubKey = (code, p) => {
    let subKeys = [
        p.CONTROL,
        p.SHIFT,
        p.ALT,
    ];

    return p.keyIsDown(code)
        && subKeys.filter(subKey => p.keyIsDown(subKey)).length === 1;
}

export { keyPressed };
